import { LOAD_USERS, SELECT_USER, CLEAN_SELECTED_USER } from "../actions/actionTypes";

const initialState = {
    users: [],
    selectedUser: null    
};

export const usersReducer = (state = initialState, action) => {
    switch (action.type) {
        case LOAD_USERS:
            return {
                ...state,
                users: action.users
            };
        case SELECT_USER:
            return {
                ...state,
                selectedUser: action.user
            };
        case CLEAN_SELECTED_USER:
            return {
                ...state,
                selectedUser: null
            };
        default:
            return state;
    }
};